import $ from 'jquery';
import screenSize from './../../../common/screen_size_util';

/* this module affects the category list styling and movement on the annual homepage */

module.exports = function () {
    var viewport = screenSize.getSize();
    var evenOdd= $('.mic-list-companies__past-years').length;

    function isEven(n) {
       return n % 2 == 0;
    }

     if (viewport === 'xxlarge' || viewport === 'xlarge') {
            $('.mic-list-companies__past-years').slice(0, 2).css('padding-top', 0);
        }

    if (viewport === 'large' || viewport === 'medium') {
        $('.mic-list-companies__past-years').slice(0, 2).css('padding-top', 0);
    }

    if (viewport === 'small') {
        $('.mic-list-companies__past-years').slice(0, 2).css('padding-top', '12px');
    }

    if(isEven(evenOdd) === true){
        if (viewport === 'large' || viewport === 'medium') {
            $('.mic-list-companies__past-years').slice(-2).addClass('mic-list-companies__no-border');
        }

        if (viewport === 'small') {
            $('.mic-list-companies__past-years').slice(-2).removeClass('mic-list-companies__no-border');
        }

    } else {
        if (viewport === 'large' || viewport === 'medium') {
            $('.mic-list-companies__past-years').last().addClass('mic-list-companies__no-border');
        }

        if (viewport === 'small') {
            $('.mic-list-companies__past-years').last().removeClass('mic-list-companies__no-border');
        }
    }

};
